<dtm-ui-input-field [isClearable]="(isClearable$ | ngrxPush) ?? false" [hasErrors]="!!timeFormControl.errors">
    <ng-content select="label" ngProjectAs="label"></ng-content>
    <input
        class="time-field"
        matInput
        autocomplete="off"
        [formControl]="timeFormControl"
        type="time"
        [step]="(shouldShowSeconds$ | ngrxPush) ? 1 : undefined"
        #timeInput
        [required]="!!(isRequired$ | ngrxPush)"
        (click)="openTimePicker(timeInput)"
    />
    <dtm-ui-icon
        class="field-suffix time-icon"
        [name]="(isUtcTime$ | ngrxPush) ? 'time-utc' : 'time'"
        (click)="openTimePicker(timeInput)"
    />
    <ng-content select=".field-hint" ngProjectAs=".field-hint"></ng-content>
    <ng-content select=".field-error" ngProjectAs=".field-error"></ng-content>
</dtm-ui-input-field>
